import { OcpsPolicy } from '@ms/yammer-data/dist/state/ocps/types';
import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

import { useIsFeedbackFormTypePolicyEnabled } from './useIsFeedbackFormTypePolicyEnabled';

export const useIsFeedbackEnabled = (
  policy: OcpsPolicy.UserFeedbackFormEnabled | OcpsPolicy.SurveyFeedbackFormEnabled
) => {
  const isFeedbackExperimentEnabled = useExperimentTreatmentWithoutReporting(Experiment.YammerFeedbackSystem) === true;
  const isFeedbackOcpsPolicyEnabled = useIsFeedbackFormTypePolicyEnabled(policy);

  return isFeedbackExperimentEnabled && isFeedbackOcpsPolicyEnabled;
};
